// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FrownOutlinedSvg from "@ant-design/icons-svg/es/asn/FrownOutlined";
import AntdIcon from '../components/AntdIcon';

var FrownOutlined = function FrownOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: FrownOutlinedSvg
  }));
};

FrownOutlined.displayName = 'FrownOutlined';
export default React.forwardRef(FrownOutlined);